/** Allowed class times shown in the form (30-min steps, 09:00–16:30). */
export const EXPERIMENTAL_CLASS_TIMES = [
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30'
]

/** One row of the listing (one per student). */
export interface IExperimentalClassRowRaw {
  id: number
  scheduling_id: number
  student_name: string
  student_age: number
  attended: boolean
  attended_at: string | null
  attended_by_name: string | null
  class_date: string
  class_time: string
  day_of_week: string
  turma: string
  course_name: string | null
  teacher_name: string | null
  consultant_name: string | null
  guardian_name: string
  guardian_email: string
  guardian_phone: string
  observations: string | null
}

/** id/name option used by the consultant, teacher and course selects. */
export interface IExperimentalClassOptionRaw {
  id: number
  name: string
}

/** A student row inside the form (age may be empty while typing). */
export interface IExperimentalClassStudentInput {
  name: string
  age: number | ''
}

/** Payload sent to the backend on create. */
export interface IExperimentalClassFormPayload {
  commercial_consultant_id: number
  teacher_id: number
  course_id: number
  turma: string
  class_date: string
  class_time: string
  guardian_name: string
  guardian_email: string
  guardian_phone: string
  students: { name: string; age: number }[]
  observations: string
}
